/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

// 路由支持修改的内容只有 component 和 meta 信息
// 详细信息路由元数据请参考：https://docs.soybeanjs.cn/zh/guide/router/intro.html
// interface RouteMeta {
//   // 路由标题，当无i18nKey时生效
//   title: string;
//   // 国际化key（目前因为项目使用了国际化，所以需要设置，在locales中配置）
//   i18nKey: string;
//   // 是否为需要登录才能访问的路由
//   constant: boolean;
//   // 是否在菜单中隐藏
//   hideInMenu: boolean;
//   // 可访问的角色列表
//   roles: string[];
//   // 排序
//   order: number;
//   // 图标
//   icon: string;
//   // 本地图标
//   localIcon: string;
//   // 图标大小
//   iconFontSize: number;
// }

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'finance-manage',
    path: '/finance-manage',
    component: 'layout.base',
    meta: {
      title: 'finance-manage',
      i18nKey: 'route.finance-manage',
      icon: 'mingcute:receive-money-line',
      order: 19
    },
    children: [
      {
        name: 'finance-manage_dashboard',
        path: '/finance-manage/dashboard',
        component: 'view.finance-manage_dashboard',
        meta: {
          order: 0,
          title: 'finance-manage_dashboard',
          i18nKey: 'route.finance-manage_dashboard'
        }
      },
      {
        name: 'finance-manage_settlement-manage',
        path: '/finance-manage/settlement-manage',
        component: 'view.finance-manage_settlement-manage',
        meta: {
          order: 2,
          title: 'finance-manage_settlement-manage',
          i18nKey: 'route.finance-manage_settlement-manage'
        }
      },
      {
        name: 'finance-manage_withdraw-manage',
        path: '/finance-manage/withdraw-manage',
        component: 'view.finance-manage_withdraw-manage',
        meta: {
          order: 1,
          title: 'finance-manage_withdraw-manage',
          i18nKey: 'route.finance-manage_withdraw-manage'
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home',
      icon: 'mingcute:chart-line-line',
      order: 1
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      keepAlive: true
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'operators',
    path: '/operators',
    component: 'layout.base',
    meta: {
      title: 'operators',
      i18nKey: 'route.operators',
      icon: 'mingcute:store-line',
      order: 2
    },
    children: [
      {
        name: 'operators_merchants-list',
        path: '/operators/merchants-list',
        component: 'view.operators_merchants-list',
        meta: {
          order: 2,
          title: 'operators_merchants-list',
          i18nKey: 'route.operators_merchants-list'
        }
      },
      {
        name: 'operators_operators-list',
        path: '/operators/operators-list',
        component: 'view.operators_operators-list',
        meta: {
          order: 1,
          title: 'operators_operators-list',
          i18nKey: 'route.operators_operators-list'
        }
      },
      {
        name: 'operators_school-list',
        path: '/operators/school-list',
        component: 'view.operators_school-list',
        meta: {
          order: 3,
          title: 'operators_school-list',
          i18nKey: 'route.operators_school-list'
        }
      }
    ]
  },
  {
    name: 'qrcode-scan',
    path: '/qrcode-scan',
    component: 'layout.blank$view.qrcode-scan',
    meta: {
      title: 'qrcode-scan',
      i18nKey: 'route.qrcode-scan',
      hideInMenu: true,
      constant: true
    }
  },
  {
    name: 'system-manage',
    path: '/system-manage',
    component: 'layout.base',
    meta: {
      title: 'system-manage',
      i18nKey: 'route.system-manage',
      icon: 'mingcute:settings-5-line',
      order: 20
    },
    children: [
      {
        name: 'system-manage_order-simulation-batch',
        path: '/system-manage/order-simulation-batch',
        component: 'view.system-manage_order-simulation-batch',
        meta: {
          title: 'system-manage_order-simulation-batch',
          i18nKey: 'route.system-manage_order-simulation-batch',
          roles: ['sys_admin'],
          order: 3
        }
      },
      {
        name: 'system-manage_role-manage',
        path: '/system-manage/role-manage',
        component: 'view.system-manage_role-manage',
        meta: {
          title: 'system-manage_role-manage',
          i18nKey: 'route.system-manage_role-manage'
        }
      },
      {
        name: 'system-manage_scope-user-list',
        path: '/system-manage/scope-user-list',
        component: 'view.system-manage_scope-user-list',
        meta: {
          title: 'system-manage_scope-user-list',
          i18nKey: 'route.system-manage_scope-user-list'
        }
      }
    ]
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center',
      hideInMenu: true
    }
  },
  {
    name: 'users',
    path: '/users',
    component: 'layout.base',
    meta: {
      title: 'users',
      i18nKey: 'route.users',
      icon: 'mingcute-wechat-miniprogram-line',
      order: 5
    },
    children: [
      {
        name: 'users_platform-user-list',
        path: '/users/platform-user-list',
        component: 'view.users_platform-user-list',
        meta: {
          order: 1,
          title: 'users_platform-user-list',
          i18nKey: 'route.users_platform-user-list'
        }
      },
      {
        name: 'users_recharge-activities',
        path: '/users/recharge-activities',
        component: 'view.users_recharge-activities',
        meta: {
          order: 4,
          title: 'users_recharge-activities',
          i18nKey: 'route.users_recharge-activities'
        }
      },
      {
        name: 'users_user-change-school',
        path: '/users/user-change-school',
        component: 'view.users_user-change-school',
        meta: {
          order: 2,
          title: 'users_user-change-school',
          i18nKey: 'route.users_user-change-school'
        }
      },
      {
        name: 'users_water-card-list',
        path: '/users/water-card-list',
        component: 'view.users_water-card-list',
        meta: {
          order: 3,
          title: 'users_water-card-list',
          i18nKey: 'route.users_water-card-list'
        }
      }
    ]
  },
  {
    name: 'water-service-manage',
    path: '/water-service-manage',
    component: 'layout.base',
    meta: {
      icon: 'mingcute:wet-line',
      order: 4,
      title: 'water-service-manage',
      i18nKey: 'route.water-service-manage'
    },
    children: [
      {
        name: 'water-service-manage_devices-dashboard',
        path: '/water-service-manage/devices-dashboard',
        component: 'view.water-service-manage_devices-dashboard',
        meta: {
          order: 1,
          title: 'water-service-manage_devices-dashboard',
          i18nKey: 'route.water-service-manage_devices-dashboard'
        }
      },
      {
        name: 'water-service-manage_flow-details',
        path: '/water-service-manage/flow-details',
        component: 'view.water-service-manage_flow-details',
        meta: {
          order: 6,
          title: 'water-service-manage_flow-details',
          i18nKey: 'route.water-service-manage_flow-details'
        }
      },
      {
        name: 'water-service-manage_outlet-manage',
        path: '/water-service-manage/outlet-manage',
        component: 'view.water-service-manage_outlet-manage',
        meta: {
          order: 4,
          title: 'water-service-manage_outlet-manage',
          i18nKey: 'route.water-service-manage_outlet-manage'
        }
      },
      {
        name: 'water-service-manage_outlet-templates',
        path: '/water-service-manage/outlet-templates',
        component: 'view.water-service-manage_outlet-templates',
        meta: {
          order: 3,
          title: 'water-service-manage_outlet-templates',
          i18nKey: 'route.water-service-manage_outlet-templates'
        }
      },
      {
        name: 'water-service-manage_water-consume-detail',
        path: '/water-service-manage/water-consume-detail',
        component: 'view.water-service-manage_water-consume-detail',
        meta: {
          title: 'water-service-manage_water-consume-detail',
          i18nKey: 'route.water-service-manage_water-consume-detail',
          order: 6
        }
      },
      {
        name: 'water-service-manage_water-devices-list',
        path: '/water-service-manage/water-devices-list',
        component: 'view.water-service-manage_water-devices-list',
        meta: {
          order: 2,
          title: 'water-service-manage_water-devices-list',
          i18nKey: 'route.water-service-manage_water-devices-list'
        }
      },
      {
        name: 'water-service-manage_water-order',
        path: '/water-service-manage/water-order',
        component: 'view.water-service-manage_water-order',
        meta: {
          title: 'water-service-manage_water-order',
          i18nKey: 'route.water-service-manage_water-order',
          order: 5
        }
      }
    ]
  }
];
